import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, label, dark = false }) => (
  <div className="flex items-center gap-4 mb-6" data-testid={`chapter-${num}`}>
    <span className={`font-display text-sm font-semibold tracking-widest ${dark ? "text-gold" : "text-gold-dark"}`}>
      {num}
    </span>
    <span className="gold-rule w-12" />
    <span className={`text-xs font-semibold uppercase tracking-[0.25em] ${dark ? "text-slate-400" : "text-slate-500"}`}>
      {label}
    </span>
  </div>
);

export default Reveal;
